import React from 'react'

import EditIcon from 'Assets/Images/icons/edit'

export const ButtonEditInlineUnstyled = props => (
  <div className={props.className} onClick={props.onClickHandler}>
    <EditIcon />
    {props.label}
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Buttons/ButtonEditInline/unstyled.js